"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var isCallable = require("./is-callable");

module.exports = function (stringifiable) {
  try {
    if (stringifiable && isCallable(stringifiable.toString)) return stringifiable.toString();
    return String(stringifiable);
  } catch (e) {
    throw new TypeError("Passed argument cannot be stringifed");
  }
};